import React from "react"
import { useSignalEffect } from "@preact/signals-react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { form_list, user_info } from "signals/user";
import { get_list_form } from "services/user";
import { localize } from "services/base";
import { List } from "component/List";


const Home = () => {
	const navigate = useNavigate();
	const t = (key) => localize(key);
	const user_form_list = form_list.value;

	useSignalEffect(() =>{
        console.log('tes selected')

		if(user_info.value){
			get_list_form()
		}
	},[])

	const renderList = () => {
		return (
			user_form_list.map((data, x) =>
				<List key={x} data={data}/>				
			)
		)
	}

	return (
		<>
			<div className="address-container">
				{(user_form_list && user_form_list.length > 0) ?
					renderList()
					:
					<p className="text-center fst-italic mb-5" style={{ color: "#5D5D5D" }}>
						{t(`address_list_empty`)}
					</p>
				}
			</div>
			{user_form_list.length < 5 &&
				<Button 
					onClick={() => navigate('/form')} 
					className="add-address px-3 py-2 m-auto d-flex" 
					variant="danger"
				>
					+ {t('add_address')}
				</Button>
			}

		</>
	)
}

export default Home
